import axios from 'axios';

const validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

const validatePhone = (phone) => {
    var re = /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
    return re.test(String(phone).toLowerCase());
};

var ENDPOINT = '';

if (process.env.ENV === 'production') {
    ENDPOINT = '';
} else {
    ENDPOINT = 'http://localhost:4080';
}

export default {
    validateForm(formData) {
        var name = formData.name,
            email = formData.email,
            phone = formData.phone,
            message = formData.message,
            validations = [false, false, false, false];

        if (name.length > 0 & name.length < 200) {
            validations[0] = true;
        }
        
        if (validateEmail(email)) {
            validations[1] = true;
        }

        if (validatePhone(phone)) {
            validations[2] = true;
        }

        if (message.length < 2000) {
            validations[3] = true;
        }

        for (var i = 0; i < 4; i++ ) {
            if (!validations[i]) {
                return false;
            }
        }

        return true;
    },

    submitForm: function(data) {
        return new Promise(function(resolve, reject) {
            axios.post(ENDPOINT + '/contactus', data)
            .then(function (response) {
                // console.log(response);
                if (window && window.dataLayer) {
                    window.dataLayer.push({
                        'event': 'custom.event.cfsuccess',
                        'custom.gtm.element': document,
                        'custom.gtm.elementClasses': '',
                        'custom.gtm.elementId': '',
                        'custom.gtm.elementTarget': '',
                        'custom.gtm.elementUrl': 'https://keus.in/contactus/',
                        'custom.gtm.originalEvent': null
                    });
                }

                resolve();
            })
            .catch(function (error) {
                console.log(error);
                reject();
            });
        });
    }
}